import { AxiosResponse } from "axios"
import ConnectApi from "../baseService"
import { TApiResponse } from "../TApiResponse"
import {
  TBusyoBetuSyaryoCountRes,
  TBusyoUriagegakuGetReq,
  TBusyoUriagegakuGetRes,
  THaisyaKensuGetReq,
  THaisyaKensuGetRes,
  TSyakenTenkenMenkyoGetReq,
  TSyakenTenkenMenkyoGetRes,
} from "./TDashboard"

/**
 * 部所マスタに対するAPIリクエスト用サービス
 *
 * @export
 * @class MenuService
 * @extends {ConnectApi}
 */
export default class DashboardService extends ConnectApi {
  /**
   * 部所売上額取得
   * @param params
   * @param signal
   * @returns
   */
  getBusyoUriagegaku = async (
    params: TBusyoUriagegakuGetReq | undefined,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<TBusyoUriagegakuGetRes>> =
        await this.getInner(`/dashboard/get/busyouriagegaku`, params, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 部所別配車件数取得
   * @param params
   * @param signal
   * @returns
   */
  getHaisyaKensu = async (
    params: THaisyaKensuGetReq | undefined,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<THaisyaKensuGetRes>> =
        await this.getInner(
          `/dashboard/get/busyobetuhaisyalensulist`,
          params,
          signal
        )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 当月営業日数取得
   * @param params
   * @param signal
   * @returns
   */
  getBusinessDay = async (signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<number>> = await this.getInner(
        `/dashboard/get/businessday`,
        {},
        signal
      )
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 部所別車輌台数取得
   * @param params
   * @param signal
   * @returns
   */
  getBusyoBetuSyaryoCount = async (signal?: AbortSignal) => {
    try {
      const res: AxiosResponse<TApiResponse<TBusyoBetuSyaryoCountRes>> =
        await this.getInner(`/dashboard/get/busyobetusyaryocount`, {}, signal)
      return res.data
    } catch (err) {
      throw err
    }
  }

  /**
   * 車検点検免許更新取得
   * @param params
   * @param signal
   * @returns
   */
  getSyakenTenkenMenkyoList = async (
    params: TSyakenTenkenMenkyoGetReq | undefined,
    signal?: AbortSignal
  ) => {
    try {
      const res: AxiosResponse<TApiResponse<TSyakenTenkenMenkyoGetRes>> =
        await this.getInner(
          `/dashboard/get/syakentenkenmenkyo/list`,
          params,
          signal
        )
      return res.data
    } catch (err) {
      throw err
    }
  }
}
